import * as React from 'react';
import { textStyleCss } from 'src/theme/atlas';
import styled from 'styled-components';

export interface CaseReportSectionTitleProps {
  children: React.ReactNode;
}

export const CaseReportSectionTitle: React.FC<CaseReportSectionTitleProps> = ({
  children,
}: CaseReportSectionTitleProps) => {
  return (
    <StyledCaseReportSectionTitle>{children}</StyledCaseReportSectionTitle>
  );
};

export const StyledCaseReportSectionTitle = styled.h5`
  ${({ theme }) => textStyleCss(theme.atlas.typography.semantic.caption)};
  font-weight: 500;
  text-transform: uppercase;
  color: ${(props) => props.theme.atlas.semantic.color.type.muted};
  margin: 0;
`;
